import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

const resolveContainer = (target) => {
  if (typeof target === "string") return document.getElementById(target);
  if (target instanceof HTMLElement) return target;

  return null;
};


window.renderWidget = (
  companyAccessName,
  containerId = "unn-presscorner-widget",
  props = {}
) => {
  const container = resolveContainer(containerId);

  if (!container) {
    console.error(" Widget container not found:", containerId);

    return;
  }

  const root = createRoot(container);
  root.render(<App companyAccessName={companyAccessName} {...props} />);
};


window.unmountWidget = (containerId = "unn-presscorner-widget") => {
  const container = resolveContainer(containerId);
  if (!container) return;

  const root = createRoot(container);
  root.unmount();
};
